import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController,NavParams } from '@ionic/angular';
import { ContactsService } from 'src/app/business-service/contacts/contacts.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { CONTACT_TYPES, ORGANIZATION_TYPES } from '../../shared/constants/api-constants';
import { LovDataService } from '../../shared/services/lov-data/lov-data.service';
import { InputValidationsService } from '../../shared/services/validations/input-validations.service';


@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
})
export class ContactFormComponent implements OnInit {

  passengerForm!: FormGroup;
  dmcForm!: FormGroup;
  vendorForm!: FormGroup;
  agentForm!: FormGroup;
  relatedTo: any;
  leadId: any;
  @Input() clientId: any = null;
  disabledRelatedTo: boolean = false;
  dmcEmails: string[] = [];
  dmcEmailError: string = '';

  editContactId: any;
  contactDetails: any;
  dmcDetails: any;
  vendorDetails: any;
  agentDetails: any;

  CONTACT_TYPES = CONTACT_TYPES;

  // Popover document
  documentType: string = '';
  otherDocumentType: string = '';
  attachedFileName: string | null = null;
  attachedFile: File | null = null;
  @ViewChild('documentResetBtn') documentResetBtn!: ElementRef;

  documentTypesArr: string[] = ["Aadhar Card", "Pan Card", "Passport", "Visa", "Others"];

  // TODO: Use LOV data from API
  vendorServices: any = [
    {
      name: "Car Rental",
      key: "Car Rental",
    },
    {
      name: "Hotels",
      key: "Hotels",
    },
    {
      name: "Cruises",
      key: "Cruises",
    },
    {
      name: "Visa",
      key: "Visa",
    },
    {
      name: "Flights",
      key: "Flights",
    },
    {
      name: "Transport",
      key: "Transport",
    }
  ]

  contactTypes: any = [
    { name: 'Passenger', key: CONTACT_TYPES.PASSENGER },
    { name: 'DMC', key: CONTACT_TYPES.DMC },
    { name: 'Vendor', key: CONTACT_TYPES.VENDOR },
    { name: 'Agent', key: CONTACT_TYPES.AGENT }
  ]

  constructor(
    private _modalController: ModalController,
    private _navParams: NavParams,
    private _fb: FormBuilder,
    private _contactService: ContactsService,
    private _responseNotificationServce: ResponseNotificationService,
    private _globalService: GlobalService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _lovDataService: LovDataService,
    private _validationService: InputValidationsService,

  ) { }

  ngOnInit() {
    this.clientId = this._navParams.get('clientId');
    this.leadId = this._navParams.get('leadId') || this.leadId;
    this.updateContactTypes();

    this.initializePassengerForm();
    this.initializeDmcForm();
    this.initializeVendorForm();
    this.initializeAgentForm();
    if (this.clientId) {
      this.passengerForm.patchValue({ clientId: this.clientId });
    }

    if (this.editContactId) {
      if (this.relatedTo === CONTACT_TYPES.PASSENGER) {
        this._contactService.getContact(this.editContactId).subscribe((data) => {
          this.contactDetails = data;
          this.populateFormWithDetails();
        });
      } else if (this.relatedTo === CONTACT_TYPES.DMC) {
        this._contactService.getDmcContact(this.editContactId).subscribe((data) => {
          this.dmcDetails = data;
          this.populateFormWithDetails();
        })
      } else if (this.relatedTo === CONTACT_TYPES.VENDOR) {
        this._contactService.getVendorContact(this.editContactId).subscribe((data) => {
          this.vendorDetails = data;
          this.populateFormWithDetails();
        })
      } else if (this.relatedTo === CONTACT_TYPES.AGENT) {
        this._contactService.getAgentContact(this.editContactId).subscribe((data) => {
          this.agentDetails = data;
          this.populateFormWithDetails();
        })
      }

    }
  }

  updateContactTypes() {
    let orgType = localStorage.getItem('CType');
    if (orgType === ORGANIZATION_TYPES.AGENT_AND_DMC) {
      this.contactTypes = [
        { name: 'Passenger', key: CONTACT_TYPES.PASSENGER },
        { name: 'DMC', key: CONTACT_TYPES.DMC },
        { name: 'Vendor', key: CONTACT_TYPES.VENDOR },
        { name: 'Agent', key: CONTACT_TYPES.AGENT }
      ]
    }else if(orgType === ORGANIZATION_TYPES.AGENT){
      this.contactTypes = [
        { name: 'Passenger', key: CONTACT_TYPES.PASSENGER },
        { name: 'DMC', key: CONTACT_TYPES.DMC },
        { name: 'Vendor', key: CONTACT_TYPES.VENDOR },
        { name: 'Agent', key: CONTACT_TYPES.AGENT }
      ]
    }else if(orgType === ORGANIZATION_TYPES.DMC){
      this.contactTypes = [
        { name: 'Vendor', key: CONTACT_TYPES.VENDOR },
        { name: 'Agent', key: CONTACT_TYPES.AGENT }
      ]
    }
  }

  get today(): Date {
    let date = new Date(this._globalService.getTodaysDateTime());
    return date;
  }
  convertToDate(value: any): Date | null {
    if (!value) {
      return null;
    }
    return new Date(value);
  }

  initializePassengerForm() {
    this.passengerForm = this._fb.group({
      contactId: [''],
      leadId: [this.leadId],
      clientId: [this.clientId || ''],
      firstName: ["", [Validators.required]],
      lastName: [""],
      phone: [{ countryCode: '+91', phone: '' }, [Validators.required]],
      email: ["", [Validators.email]],
      dateOfBirth: [null],
      gender: ["Prefer not to say"],
      company: [""],
      document: this._fb.array([]),
      organizationId: [''],
      createDate: [this._globalService.getTodaysDateTime()],
      createdBy: [''],
      id: [''],
      ownership: [''],
      ownershipRole: ['']
    });
  }

  initializeDmcForm(): void {
    this.dmcForm = this._fb.group({
      dmcId: [''],
      organizationName: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: [''],
      primaryPhoneNumber: ['', Validators.required],
      secondaryPhoneNumber: [''],
      emails: [[], Validators.required],
      locations: [[]],
      websiteLink: [''],
      rating: [''],
      address1: ['', Validators.required],
      address2: [''],
      city: [''],
      state: [''],
      zipCode: [''],
      country: [''],
      notes: [''],
      organizationId: [''],
      id: [''],
      ownership: [''],
      ownershipRole: [''],
      createDate: [this._globalService.getTodaysDateTime()],
      createdBy: ['']
    });
  }

  initializeVendorForm(): void {
    this.vendorForm = this._fb.group({
      vendorId: [''],
      organizationName: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: [''],
      primaryPhoneNumber: ['', Validators.required],
      secondaryPhoneNumber: [''],
      email: ['', [Validators.email, Validators.required]],
      serviceTypes: [[], this._validationService.atLeastOneItemSelectedValidator()],
      websiteLink: [''],
      rating: [''],
      address1: ['', Validators.required],
      address2: [''],
      city: [''],
      state: [''],
      zipCode: [''],
      country: [''],
      notes: [''],
      organizationId: [''],
      id: [''],
      ownership: [''],
      ownershipRole: [''],
      createDate: [this._globalService.getTodaysDateTime()],
      createdBy: ['']
    });
  }

  initializeAgentForm(): void {
    this.agentForm = this._fb.group({
      agentId: [''],
      organizationName: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: [''],
      primaryPhoneNumber: ['', Validators.required],
      secondaryPhoneNumber: [''],
      email: ['', [Validators.email, Validators.required]],
      locations: [[]],
      websiteLink: [''],
      rating: [''],
      address1: ['', Validators.required],
      address2: [''],
      city: [''],
      state: [''],
      zipCode: [''],
      country: [''],
      notes: [''],
      organizationId: [''],
      id: [''],
      ownership: [''],
      ownershipRole: [''],
      createDate: [this._globalService.getTodaysDateTime()],
      createdBy: ['']
    });
  }

  populateFormWithDetails() {
    if (this.relatedTo === CONTACT_TYPES.PASSENGER) {
      this.passengerForm.patchValue({
        contactId: this.contactDetails.contactId,
        leadId: this.contactDetails.leadId,
        firstName: this.contactDetails.firstName,
        lastName: this.contactDetails.lastName,
        phone: { countryCode: this.contactDetails.phoneCountryCode, phone: this.contactDetails.phoneNumber },
        email: this.contactDetails.email,
        dateOfBirth: this.contactDetails.dateOfBirth ? this.convertToDate(this.contactDetails.dateOfBirth) : null,
        gender: this.contactDetails.gender || "",
        company: this.contactDetails.company || "",
        organizationId: this.contactDetails.organizationId,
        createDate: this.contactDetails.createDate,
        createdBy: this.contactDetails.createdBy,
        id: this.contactDetails.id,
        ownership: this.contactDetails.ownership,
        ownershipRole: this.contactDetails.ownershipRole
      });

      if (this.contactDetails.document) {
        this.contactDetails.document.forEach((doc: any) => {
          this.documentsAttached.push(this._fb.group({
            documentCategory: doc.documentCategory,
            file: null,  // File can't be reloaded, so this remains null
            path: doc.path,
            fileName: doc.fileName
          }));
          this.documentTypesArr = this.documentTypesArr.filter(item => item !== doc.documentCategory);
        });
      }
    } else if (this.relatedTo === CONTACT_TYPES.DMC) {
    this.dmcForm.patchValue(this.dmcDetails);
    if (this.dmcDetails.emails?.length > 0) {
    this.dmcEmails = this.dmcDetails.emails;
  } else if (this.dmcDetails.email) {
    this.dmcEmails = this.dmcDetails.email
      .split(',')
      .map((x: string) => x.trim())
      .filter((x: string) => x);
  }
    } else if (this.relatedTo === CONTACT_TYPES.VENDOR) {
      this.vendorForm.patchValue(this.vendorDetails);
    } else if (this.relatedTo === CONTACT_TYPES.AGENT) {
      this.agentForm.patchValue(this.agentDetails);
    }
  }


  get documentsAttached(): FormArray {
    return this.passengerForm.get('document') as FormArray;
  }

  onDocumentTypeChange() {
    if (this.documentType !== 'Others') {
      this.otherDocumentType = '';
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    // Checking if image is more than 10MB
    if (file.size > 10 * 1024 * 1024) {
      this._globalService.customAlert("File size should be less than 10MB", "Invalid File Size");
      return;
    }
    if (file) {
      this.attachedFileName = file.name;
      this.attachedFile = file;
    }
  }

  openAttachedFile() {
    if (this.attachedFile) {
      const fileURL = URL.createObjectURL(this.attachedFile);
      // window.open(fileURL);
      this._modalPopupService.openImageModal(fileURL);
    }
  }
  openExistingFile(filePath: string) {
    // window.open(filePath, '_blank');
    this._modalPopupService.openImageModal(filePath);
  }

  resetAttachemenForm() {
    this.documentType = '';
    this.otherDocumentType = '';
    this.attachedFileName = null;
    this.attachedFile = null;
    this.documentResetBtn.nativeElement.click();
  }

  submitAttachmentForm() {
    if (this.documentType && this.attachedFile) {
      const doctype = this.documentType === 'Others' ? this.otherDocumentType : this.documentType;
      this.addTypeAndAttachmentToForm(doctype, this.attachedFile);
    }
  }

  addTypeAndAttachmentToForm(doctype: string, file: File) {
    // Implement your logic here
    let group = this._fb.group({
      documentCategory: doctype,
      file: file
    })

    this.documentsAttached.push(group);
    this.resetAttachemenForm();

    this.documentTypesArr = this.documentTypesArr.filter(item => item !== doctype)
  }

  removeDoucment(i: any) {
    let attachedFileRecord = this.documentsAttached.value[i];
    if (attachedFileRecord.path) {
      this._contactService.deleteContactAttachment(this.editContactId, attachedFileRecord.documentCategory).subscribe((data) => {
        if (data) {
          this.documentTypesArr.unshift(attachedFileRecord.documentCategory);
          this.documentsAttached.removeAt(i);
        }
      }, (error) => {
        this._responseNotificationServce.showMessage('Failed to delete document.', true);
      })
    } else {
      this.documentTypesArr.unshift(attachedFileRecord.documentCategory);
      this.documentsAttached.removeAt(i);
    }

  }

  openFile(file: File) {
    const fileURL = URL.createObjectURL(file);
    // window.open(fileURL);
    this._modalPopupService.openImageModal(fileURL);
  }

  closeModal() {
    this._modalController.dismiss()
  }

  onSubmit(goNew: boolean) {

    if (this.relatedTo === CONTACT_TYPES.PASSENGER) {
      if (this.passengerForm.valid) {
        let phoneNumber = this.passengerForm.get('phone')?.value;
        let dob = this.convertToDate(this.passengerForm.get('dateOfBirth')?.value) ? this._globalService.convertDateToString(this.convertToDate(this.passengerForm.get('dateOfBirth')?.value)) : '';
        const formData = new FormData();
        // Append simple fields
        formData.append('contactId', this.passengerForm.get('contactId')?.value);
        formData.append('leadId', this.passengerForm.get('leadId')?.value);
        formData.append('clientId', this.clientId || '');
        formData.append('firstName', this.passengerForm.get('firstName')?.value);
        formData.append('lastName', this.passengerForm.get('lastName')?.value);
        formData.append('phoneNumber', phoneNumber.phone);
        formData.append('phoneCountryCode', phoneNumber.countryCode);
        formData.append('email', this.passengerForm.get('email')?.value);
        formData.append('dateOfBirth', dob);
        formData.append('gender', this.passengerForm.get('gender')?.value);
        formData.append('company', this.passengerForm.get('company')?.value);
        formData.append('organizationId', this.passengerForm.get('organizationId')?.value);
        formData.append('createDate', this.passengerForm.get('createDate')?.value);
        formData.append('createdBy', this.passengerForm.get('createdBy')?.value);
        formData.append('id', this.passengerForm.get('id')?.value);
        formData.append('ownership', this.passengerForm.get('ownership')?.value);
        formData.append('ownershipRole', this.passengerForm.get('ownershipRole')?.value);
        // Append documents
        const documents = this.passengerForm.get('document')?.value;
        let index = 0;
        documents.forEach((doc: { file: File | null; documentCategory: string; path?: string }) => {
          if (doc.file) {
            formData.append(`document[${index}].file`, doc.file);
            formData.append(`document[${index}].documentCategory`, doc.documentCategory);
            index++;
          }
        });
        if (this.editContactId) {
          this._contactService.updateContact(this.editContactId, formData).subscribe((data) => {
            this._reloadService.triggerContactsReload();
            this._responseNotificationServce.showMessage("Contact Updated Successfully");
            this.ngOnInit();
            this.closeModal();
          })
        } else {
          this._contactService.addContact(formData).subscribe((data) => {
            this._reloadService.triggerContactsReload();
            this._responseNotificationServce.showMessage("Contact Added Successfully");
            if (goNew) {
              this.closeModal();
              this._modalPopupService.openContactForm(this.relatedTo, this.leadId, null, this.disabledRelatedTo, () => { })
            } else {
              this.closeModal();
            }
          })
        }
      } else {
        this.passengerForm.markAllAsTouched();
        this._globalService.scrollToFirstInvalidControl();
        this._globalService.customAlert("Form is invalid, please fill all required fields.");
        // this._responseNotificationServce.showMessage("Form is invalid, please fill all required fields.", true);
      }
    } else if (this.relatedTo === CONTACT_TYPES.DMC) {
      if (this.dmcForm.valid) {
        if (this.editContactId) {
          this._contactService.updateDmcContact(this.editContactId, this.dmcForm.getRawValue()).subscribe((data) => {
            this._reloadService.triggerDMCContactsReload();
            this._responseNotificationServce.showMessage("DMC Contact Updated Successfully");
            this.closeModal();
          })
        } else {
          this._contactService.addDmcContact(this.dmcForm.getRawValue()).subscribe((data) => {
            this._reloadService.triggerDMCContactsReload();
            this._responseNotificationServce.showMessage("DMC Contact Added Successfully");
            if (goNew) {
              this.closeModal();
              this._modalPopupService.openContactForm(this.relatedTo, this.leadId, null, this.disabledRelatedTo, () => { })
            } else {
              this.closeModal();
            }
          })
        }

      } else {
        this.dmcForm.markAllAsTouched();
        this._globalService.scrollToFirstInvalidControl();
        this._globalService.customAlert("Form is invalid, please fill all required fields.");
        // this._responseNotificationServce.showMessage("Form is invalid, please fill all required fields.", true);
      }
    } else if (this.relatedTo === CONTACT_TYPES.VENDOR) {
      if (this.vendorForm.valid) {
        if (this.editContactId) {
          this._contactService.updateVendorContact(this.editContactId, this.vendorForm.getRawValue()).subscribe((data) => {
            this._reloadService.triggerVendorContactsReload();
            this._responseNotificationServce.showMessage("Vendor Contact Updated Successfully");
            this.closeModal();
          })
        } else {
          this._contactService.addVendorContact(this.vendorForm.getRawValue()).subscribe((data) => {

            this._reloadService.triggerVendorContactsReload();
            this._responseNotificationServce.showMessage("Vendor Contact Added Successfully");
            if (goNew) {
              this.closeModal();
              this._modalPopupService.openContactForm(this.relatedTo, this.leadId, null, this.disabledRelatedTo, () => { })
            } else {
              this.closeModal();
            }
          })
        }


      } else {
        this.vendorForm.markAllAsTouched();
        this._globalService.scrollToFirstInvalidControl();
        this._globalService.customAlert("Form is invalid, please fill all required fields.");
        // this._responseNotificationServce.showMessage("Form is invalid, please fill all required fields.", true);
      }
    } else if (this.relatedTo === CONTACT_TYPES.AGENT) {
      if (this.agentForm.valid) {
        if (this.editContactId) {
          this._contactService.addAgentContact(this.agentForm.getRawValue()).subscribe((data) => {
            this._reloadService.triggerAgentContactsReload();
            this._responseNotificationServce.showMessage("Agent Contact Updated Successfully");
            this.closeModal();
          })
        } else {
          this._contactService.addAgentContact(this.agentForm.getRawValue()).subscribe((data) => {

            this._reloadService.triggerAgentContactsReload();
            this._responseNotificationServce.showMessage("Agent Contact Added Successfully");
            if (goNew) {
              this.closeModal();
              this._modalPopupService.openContactForm(this.relatedTo, this.leadId, null, this.disabledRelatedTo, () => { })
            } else {
              this.closeModal();
            }
          })
        }


      } else {
        this.agentForm.markAllAsTouched();
        this._globalService.scrollToFirstInvalidControl();
        this._globalService.customAlert("Form is invalid, please fill all required fields.");
        // this._responseNotificationServce.showMessage("Form is invalid, please fill all required fields.", true);
      }
    }
  }
  removeDmcEmail(index: number) {
    this.dmcEmails.splice(index, 1);
    this.dmcForm.patchValue({
      emails: this.dmcEmails
    });
  }
  addDmcEmail(event: any) {
    const email = event.target.value?.trim();
    this.dmcEmailError = '';
    if (!email) return;
    // Format validation
    const emailPattern = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      this.dmcEmailError = 'Invalid email format';
      return;
    }
    const isDuplicate = this.dmcEmails.some(
      e => e.trim().toLowerCase() === email.toLowerCase()
    );
    if (isDuplicate) {
      this.dmcEmailError = 'This email is already added';
      return;
    }
    // Limit validation
    if (this.dmcEmails.length >= 5) {
      this.dmcEmailError = 'Maximum 5 emails allowed';
      return;
    }
    this.dmcEmails.push(email);
    this.dmcForm.patchValue({ emails: this.dmcEmails });
    event.target.value = '';
  }
}
